import { render, staticRenderFns } from "./VideoSearchByVideo.vue?vue&type=template&id=d823502c&scoped=true"
import script from "./VideoSearchByVideo.vue?vue&type=script&lang=js"
export * from "./VideoSearchByVideo.vue?vue&type=script&lang=js"
import style0 from "./VideoSearchByVideo.vue?vue&type=style&index=0&id=d823502c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.34_babel-core@7.0.0-bridge.0_@babel+core@7.29._9691e8a1bbcd57691b862420a6e71e49/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d823502c",
  null
  
)

export default component.exports